import React from "react";
//import Slider from "react-carousel-responsive";
//import "react-carousel-responsive/dist/styles.css";
import { useSelector, useDispatch } from "react-redux";
import { getEndUserAction } from "../../../Store/Coupons/actions";
import { BASE_URL } from "../../../Config/axiosInstance";
// import "./styles.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const HomeBanner = () => {
  const dispatch = useDispatch();
  const { getEndUser } = useSelector((state) => state.Coupon);

  var BannerList = getEndUser.filter(function (el) {
    return el.banner_dimension === "1480 * 630";
  });
  

  var settings = {
    autoplay: true,
    autoplaySpeed: 3000,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  // React.useEffect(() => {
  //   dispatch(getEndUserAction());
  // }, [dispatch]);

  return (
    <Slider  {...settings} >
      {BannerList &&
        BannerList?.map((slide, i) => (
          <div 
            key={i}
            // data-background={slide?.image_upload}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              width: "100%",
              // height: "100%",
            }}
            onClick={() => window.open(slide?.redirect_url, "_blank")}
          >

            {slide?.banner_dimension === "1480 * 630" && (
              <a href={slide?.redirect_url} style={{display: "flex",justifyContent: "center", alignItems:'center',}}>
                <img
                  style={{
                    width: "100%",
                    // height: "100%",
                    objectFit: "contain",
                  }}
                  src={
                    slide?.image_upload
                      ? `${BASE_URL}/${slide?.image_upload}`
                      : slide?.image_url
                  }
                  alt=""
                  loading="lazy"
                  className="cursor-pointer"
                />
              </a>
            )}
          </div>
        ))}
    </Slider>
  );
};

export default HomeBanner;
